import React, { useEffect, useState } from "react";
import { useLocation, Redirect } from "react-router-dom";
import { ICodeValidationResponse } from "../models/ICodeValidationResponse";
import useApiRequest from "../hooks/useApiRequest";
import CodeSuccess from "./CodeValidation/CodeSuccess";
import CodeFail from "./CodeValidation/CodeFail";
import SelectVrm from "../components/SelectVrm";
import Validating from "../components/Validating";
import { resolveTypeReferenceDirective } from "typescript";

const CodeValidation = () => {
  let param = new URLSearchParams(useLocation().search);

  const [showRedirect, setShowRedirect] = useState(false);
  const [redirectSearch, setRedirectTo] = useState("");
  const [siteId, setSiteId] = useState(0);
  const [code, setCode] = useState("");
  const [vrm, setVrm] = useState("");
  const [showVrm, setShowVrm] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [codeValidation, setCodeValidation] = useState<ICodeValidationResponse>();

  const { apiRequest, error, isProcessing } = useApiRequest();

  useEffect(() => {
    ValidateParams();
  }, []);

  const ValidateParams = () => {
    setShowVrm(false);
    (async () => {
      try {

        const dateNow = new Date();
        const paramHash = param.get("go") !== undefined ? param.get("go") : "";

        var siteId = param.get("siteId") !== undefined ? Number(param.get("siteId")) : 0;
        var code = param.get("code") !== null ? param.get("code") : "";
        var hasHash = false;

        if ((siteId != 0) && (code != ""))
        {

          const paramHash = btoa([dateNow.valueOf().toString(), siteId.toString(), code ].join(';'));
          const redirectUrl = window.location.pathname + "?go=" + encodeURIComponent(paramHash);
          
          setRedirectTo(redirectUrl);
          setShowRedirect(true);

          siteId = 0;
          code = "";

        }
        else if (paramHash != null)
        {
          
          var args = atob(paramHash ?? "").split(';');
          var hashDateDiff = dateNow.valueOf() - Number(args[0]);
          hasHash = true;
          if (0 <= hashDateDiff && hashDateDiff <= 60000)
          {
            siteId = Number(args[1]);
            code = args[2];
          } 
        }
        
        if (hasHash)
        {
          if ((siteId != 0) && (code != ""))
          {
            setSiteId(siteId);
            setCode(code !== null ? code : "");

            const result = await apiRequest(
              "GET",
              `/v1/codes?siteId=${siteId}&code=${encodeURIComponent(code !== null ? code : "")}`
            );
            if (result.data == "OK")
            {  
              setShowVrm(true);
            }
            else
            {
              setSuccess(false);
              setMessage("There was a problem validating your parking. Please try again.");
            }
          }
          else
          {
            setSuccess(false);
            setMessage("You cannot use a saved link. Please rescan the parking validation QR code.");
          }
        }
        else
        {
          setMessage("Please scan a parking validation QR code to begin.");
        }
        

      } catch (error) {
        if (error.response !== undefined) {
          if (error.response.status === 422) {
            switch(error.response.data)
            {
              case "INVALID_CODE":
                setMessage("This code was not recognised. Please contact a member of our team for help.");
                break;
              case "EXPIRED_CODE":
                setMessage("This code is no longer active. Please contact a member of our team for help.");
                break;
              case "FUTURE_CODE":
                setMessage("This code is not yet active. Please contact a member of our team for help.");
                break;
              default:
                setMessage(error.response.data);
            }
            
          } else {
            setMessage("There was a problem validating your parking. Please try again.");
          }
        } else {
          setMessage("There was a problem validating your parking. Please try again.");
        }
      }
    })();
  };

  const handleNext = () => {
    (async () => {
      try {
        const item = {
          siteId: siteId,
          code: code,
          vrm: vrm,
        };

        const result = await apiRequest("POST", "/v1/codes", item);

        if (result.data.vrm)
        {
          setShowVrm(false);
          setSuccess(true);
          setCodeValidation({
            vrm: result.data.vrm,
            site: result.data.site,
            validTo: result.data.validTo
          });
        }
        else
        {
          setMessage("There was a problem validating your parking. Please try again.");
        }
      } catch (error) {
        if (error.response.status === 422) {
          setMessage(error.response.data);
        } else {
          setMessage("There was a problem validating your parking. Please try again.");
        }
      }
    })();
  };
  return (
      <div>
        {showRedirect && <Redirect to={redirectSearch} />}
        {showVrm && <SelectVrm next={handleNext} onChange={setVrm} disabled={isProcessing} />}
        {isProcessing && <Validating />}
        {success && codeValidation && <CodeSuccess item={codeValidation} />}
        {!success && <CodeFail message={message} />}
      </div>
  );
};

export default CodeValidation;
